var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header_inner"},[_c('div',{staticClass:"back_btn",on:{"click":_vm.handleBack}},[_c('div',{staticClass:"back_icon",style:(_vm.backIconStyle)})]),_c('div',{staticClass:"header_title",style:({ color: _vm.color })},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.title))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }